import { CalendarDaysIcon, ClockIcon } from "@heroicons/react/24/outline"
import { classNames } from "../../utils/styling-utils"
import type { TEnkIWPAvailabilityDay, TEnkIWPTimeSlot } from "../../api/api-iwp-server"

/** Format ISO datum string naar Nederlandse weergave */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return dateStr
  return date.toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" })
}

/** Kaart voor een dag met tijdblokken */
export default function DagCard({
  dag,
  selectedSlot,
  onSelectSlot,
}: {
  dag: TEnkIWPAvailabilityDay
  selectedSlot: { dag: TEnkIWPAvailabilityDay; slot: TEnkIWPTimeSlot } | null
  onSelectSlot: (slot: TEnkIWPTimeSlot) => void
}) {
  const hasAvailable = dag.slots.some((s) => s.beschikbaar)

  return (
    <div className={classNames(
      "rounded-lg border p-4",
      hasAvailable ? "border-gray-200 bg-white" : "border-gray-100 bg-gray-50"
    )}>
      <div className="flex items-center gap-2 mb-3">
        <CalendarDaysIcon className="h-5 w-5 text-gray-400" />
        <span className="text-sm font-semibold text-gray-900">{dag.dagNaam}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {dag.slots.map((slot) => {
          const isSelected =
            selectedSlot?.dag.datum === dag.datum &&
            selectedSlot?.slot.tijdblokId === slot.tijdblokId
          return (
            <button
              key={slot.tijdblokId}
              disabled={!slot.beschikbaar}
              onClick={() => onSelectSlot(slot)}
              aria-label={`${dag.dagNaam} ${slot.beginTijd} tot ${slot.eindTijd}${!slot.beschikbaar ? " - niet beschikbaar" : ""}${isSelected ? " - geselecteerd" : ""}`}
              className={classNames(
                "flex flex-col items-center rounded-md border px-3 py-2 text-sm transition",
                slot.beschikbaar
                  ? isSelected
                    ? "border-primary bg-primary/10 text-primary ring-1 ring-primary"
                    : "border-gray-200 bg-white text-gray-700 hover:border-primary hover:bg-primary/5 cursor-pointer"
                  : "border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed"
              )}
            >
              <ClockIcon className="h-4 w-4 mb-1" />
              <span className="font-medium">{slot.omschrijving ?? `${slot.beginTijd} - ${slot.eindTijd}`}</span>
              {slot.omschrijving && <span className="text-xs text-gray-400">{slot.beginTijd} - {slot.eindTijd}</span>}
              {!slot.beschikbaar && <span className="text-xs mt-0.5">Vol</span>}
            </button>
          )
        })}
      </div>
    </div>
  )
}
